import * as React from 'react';
import * as ReactDOM from 'react-dom';

const Portal = (props: Props) => {
	const popupPortalRoot = document.getElementById('app');
	return ReactDOM.createPortal(props.children, popupPortalRoot);
};

interface Props {
	children: React.ReactElement<unknown>;
}

export default Portal;
